module.exports = __webpack_public_path__ + "c7da1b66230aa875501f495e35e5850f.png";